import { Injectable } from '@angular/core';
import { dateFromISOString } from '@wz-utilities/date.utilities';
import { AgencyModels } from 'models/agency.models';
import { TableModels } from 'models/table.models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AgencyProjector } from '../projectors/agency-projector';
import { projectPaginatedResult } from '../projectors/table-projectors';
import { BrokerApiService } from './api/broker-api.service';
import { LocalStorageService } from './storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class BrokerService {
  constructor(
    private apiService: BrokerApiService,
    private storageService: LocalStorageService,
  ) {}

  setAllowedProduct(brokerId: number, rights: number[]) {
    return this.apiService.setAllowedProduct(brokerId, rights);
  }

  getAgencyDetails(): Observable<AgencyModels.AgencyDetails> {
    return this.apiService
      .getAgencyDetails()
      .pipe(map(AgencyProjector.agencyDetailsResponse));
  }

  getUnpaidReceipts(
    request: TableModels.PaginatedRequest,
  ): Observable<TableModels.PaginatedResult<any>> {
    return this.apiService.getUnpaidReceipts(request).pipe(
      map((res) =>
        projectPaginatedResult(res, (x) => ({
          ...x,
          paymentOrder: x.paymentOrder
            ? {
                ...x.paymentOrder,
                creationDate: dateFromISOString(x.paymentOrder.creationDate),
                paymentDate: dateFromISOString(x.paymentOrder.paymentDate!),
                expiracyDate: dateFromISOString(x.paymentOrder.expiracyDate),
              }
            : null,
        })),
      ),
    );
  }

  setRequestLastStateAsSeen(stateId: number) {
    this.storageService.addToList('REQUEST_STATES_SEEN', stateId, true);
  }

  checkIfAlreadySeenRequestState(stateId: number) {
    const arr = this.storageService.getObject<Array<number>>(
      'REQUEST_STATES_SEEN',
    );
    return arr && arr.indexOf(stateId) !== -1;
  }

  archiveSubBroker(agencyId: number) {
    return this.apiService.archiveSubBroker(agencyId);
  }
}
